import translate from '@/lib/intl/translate';
import { createApiRequest } from '@/utils/services';
import showErrorMessage from '@/utils/toasts/showErrorMessage';
import showSuccessMessage from '@/utils/toasts/showSuccessMessage';

export async function deleteComm(commsId, ownerOrgId) {
  try {
    await createApiRequest({
      method: 'delete',
      path: `comms/${commsId}?owner_org_id=${ownerOrgId}`,
      throwErrors: true,
    });
    showSuccessMessage({
      message: translate('DELETE_INTERACTION_SUCCESS_MESSAGE'),
    });
  } catch (e) {
    showErrorMessage({
      message: translate('DELETE_INTERACTION_ERROR_MESSAGE'),
    });
  }
}
